import { useUserStore } from "shared/stores/user";

type ReturnToQueryValue = string | string[] | null | undefined;

export function normalizeReturnTo(value: ReturnToQueryValue): string {
  if (Array.isArray(value)) return value[0] ?? "";

  return value ?? "";
}

export function isAllowedReturnTo(url: string): boolean {
  try {
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

    if (!apiBaseUrl) return false;

    const parsed = new URL(url);
    const apiBase = new URL(String(apiBaseUrl));

    return parsed.protocol === "https:" && parsed.host === apiBase.host;
  } catch {
    return false;
  }
}

export function submitOAuthSession(returnTo: ReturnToQueryValue) {
  const normalized = normalizeReturnTo(returnTo);

  if (!normalized || !isAllowedReturnTo(normalized)) return;

  const { token } = useUserStore();
  const accessToken = typeof token === "string" ? token : token.token;

  const url = new URL(normalized);
  const form = document.createElement("form");
  form.action = url.toString();
  form.method = "POST";
  form.style.display = "none";

  const tokenInput = document.createElement("input");
  tokenInput.name = "token";
  tokenInput.type = "hidden";
  tokenInput.value = accessToken;

  form.append(tokenInput);
  document.body.append(form);
  form.submit();
}
